export const watch = {
  hoaId() {
    this.refresh()
  },
  selectedTargetString() {
    this.reloadGridsWithTargetDate()
  }
}
